import {useWindowSize} from "../hooks/useWindowSize";

interface Props {
    children: React.ReactNode;
}
const Layout = ({children}:Props) => {
    const {height} = useWindowSize()

    return(
        <>
            <div  style={{minHeight: `${height}px`, background: '#e1eaec'}}>
                <div className="grid justify-center">
                    <div className="mt-6 body-movil sm:w-[600px] md:w-[800px] lg:w-[1100px]">
                        <main>{children}</main>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Layout;
